"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Travel = function Travel(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "40",
    height: "40",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 20.777,12.789l-8.886,2.987L10.7,14.593l-1.766,0.593c-0.393,0.132-0.604,0.557-0.472,0.95 c0.032,0.096,0.084,0.185,0.152,0.261l2.389,2.674c0.4,0.449,1.03,0.615,1.6,0.422l2.617-0.879l-0.53,3.78 c-0.058,0.41,0.227,0.789,0.636,0.847c0.116,0.016,0.234,0.006,0.345-0.032l1.361-0.457c0.211-0.071,0.379-0.232,0.46-0.439 l1.994-5.133l2.488-0.836c0.982-0.331,1.509-1.396,1.177-2.378s-1.396-1.509-2.378-1.177l0,0L20.777,12.789z ",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 18.289,13.625 l-2.78-1.914c-0.194-0.134-0.44-0.168-0.664-0.093l-1.338,0.45c-0.392,0.131-0.604,0.556-0.473,0.948 c0.037,0.111,0.1,0.212,0.183,0.294l1.517,1.51 ",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 8.25,20.249h-4.5c-1.657,0-3-1.343-3-3v-9c0-1.657,1.343-3,3-3h13.5 c1.657,0,3,1.343,3,3v1.5 ",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 6,5.249v15 ",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 15,5.249v3.75 ",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 13.5,5.249v-3c0-0.828-0.672-1.5-1.5-1.5l0,0H9c-0.828,0-1.5,0.672-1.5,1.5 l0,0v3",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    stroke: fill
  })));
};
Travel.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Travel.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Travel;